import React, { useState } from "react";
import { Upload, Button, message, Spin } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import drEasyApi from "../../Api/Customapi";
import { getImg } from "../../Api/getImg";

const ImageUploader = ({ form, value, spec = false }) => {
  const [uploading, setUploading] = useState(false);
  const [previewId, setPreviewId] = useState(value);

  const handleUpload = async ({ file, onSuccess, onError }) => {
    setUploading(true);
    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await drEasyApi.post("/api/Storage/UploadImage", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      const imageId = res.data.id;
      spec
        ? form.setFieldsValue({ photoId: imageId })
        : form.setFieldsValue({ photoID: imageId });
      setPreviewId(imageId);
      message.success("Image uploaded successfully");
      onSuccess?.();
    } catch (err) {
      message.error("Failed to upload image");
      onError?.(err);
    } finally {
      setUploading(false);
    }
  };

  return (
    <>
      <Upload
        name="file"
        showUploadList={false}
        customRequest={handleUpload}
        accept=".jpg,.jpeg,.png"
      >
        <Button icon={<UploadOutlined />} loading={uploading}>
          Upload Image
        </Button>
      </Upload>

      {uploading && <div className="mt-2">{/* <Spin /> */}</div>}

      {previewId && !uploading && (
        <img
          src={getImg(previewId)}
          alt="Preview"
          className="mt-2 rounded max-h-40"
        />
      )}
    </>
  );
};

export default ImageUploader;
